import { UserServerResponse } from 'src/core/types/user';

const app_id = import.meta.env.VITE_INTERCOM_APP_ID;
const isDevelopment =
  (import.meta.env.VITE_ENV && import.meta.env.VITE_ENV === 'dev') || false;

export const initializeIntercom = async (user: UserServerResponse) => {
  // Early return if not in development - prevents loading Intercom in production
  if (!isDevelopment) return;
  if (!user) return;

  // Dynamic import - only loads Intercom SDK in development builds
  const { default: Intercom } = await import('@intercom/messenger-js-sdk');

  const { id, first_name, last_name, email, customer } = user;
  const user_id = id.toString();
  const name = `${first_name} ${last_name}`;
  const created_at = customer?.created_at
    ? Math.floor(new Date(customer.created_at).getTime() / 1000)
    : Math.floor(Date.now() / 1000);

  Intercom({
    app_id,
    user_id,
    name,
    email,
    created_at,
  });
};

export const shutdownIntercom = async () => {
  if (!isDevelopment) return;
  if (typeof window.Intercom === 'function') {
    window.Intercom('shutdown');
  }
};

export const isIntercomActive = () => {
  return typeof window.Intercom === 'function';
};
